<app-modal
  [title]="'Reservation customer name' | trans:'cart/reservation-customer-name-modal/header/title'"
  maxWidth="1200px"
  minWidth="30%"
  width="fit-content"
  [compact]="true"
>
  <ng-template>
    <div>
      <app-form-control
        label="{{ 'Customer name'| trans:'cart/reservation-customer-name-modal/customerName.Label' }}"
      >
        <input
          type="text"
          [(ngModel)]="customerName"
          placeholder="{{ 'Enter customer name'| trans:'cart/reservation-customer-name-modal/customerName.Placeholder' }}"
        >
      </app-form-control>

      <div class="d-flex justify-content-flex-end m-t-auto p-t-4">
        <div class="width-fit-content p-4 base-border-radius c-bg-blue-200 p3">
          {{ 'Reservation code'| trans:'cart/reservation-customer-name-modal/reservationCode.Label' }} {{ data }}
        </div>
      </div>
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="close()"
      >
        {{ 'Cancel'| trans:'cart/reservation-customer-name-modal/cancel.Button' }}
      </button>
      <button
        class="button button--md button--primary text-uppercase"
        (click)="confirm.emit({ customerName, reservationCode: data }); close()"
      >
        {{ 'Confirm'| trans:'cart/reservation-customer-name-modal/confirm.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>
